import { useTranslation } from "react-i18next";
import React from "react";

interface CartItemProps {
  title: string;
  adultPrice: number;
  childPrice: number;
  adultQty: number;
  childQty: number;
  totalPrice: number;
}

const CartItem: React.FC<CartItemProps> = ({
  title,
  adultPrice,
  childPrice,
  adultQty,
  childQty,
  totalPrice,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center border-b py-4">
      <div>
        <h3 className="font-bold">{title}</h3>
        <p>
          {t("Adult: ")}
          {adultQty} x ${adultPrice}
        </p>
        <p>
          {t("Child: ")}
          {childQty} x ${childPrice}
        </p>
      </div>
      <p className="font-bold">${totalPrice}</p>
    </div>
  );
};

export default CartItem;
